var map = {
	"./en-US/Establishments-Import-Framework.csv": 28857,
	"./en-US/Establishments-Import-Framework.xlsx": 10909,
	"./esp/Modelo-Importacion-Establecimientos.csv": 26479,
	"./esp/Modelo-Importacion-Establecimientos.xlsx": 30256,
	"./pt-BR/Modelo-Importacao-Estabelecimentos.csv": 51898,
	"./pt-BR/Modelo-Importacao-Estabelecimentos.xlsx": 55288
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2692;